export default __webpack_public_path__ + "static/media/radeon.af1c9780.png";